<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h6 class="mb-0">Mano de Obra por Servicio</h6>
        <div class="d-flex align-items-center gap-2">
          <input
            v-model="search"
            type="text"
            class="form-control form-control-sm"
            style="max-width: 180px;"
            placeholder="Buscar servicio..."
            @input="onSearch"
          />
          <input
            v-model="selectedMonth"
            type="number"
            min="1"
            max="12"
            class="form-control form-control-sm"
            style="width: 70px;"
            placeholder="Mes"
            @change="resetAndLoad"
          />
          <input
            v-model="selectedYear"
            type="number"
            min="2020"
            max="2099"
            class="form-control form-control-sm"
            style="width: 90px;"
            placeholder="Año"
            @change="resetAndLoad"
          />
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
      <div v-else-if="data">
        <div class="px-3 mb-3">
          <div class="row g-3">
            <div class="col-4">
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">Total Servicios</p>
                <h5 class="font-weight-bolder mb-0">{{ data.totals.count }}</h5>
              </div>
            </div>
            <div class="col-4">
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">Total Ingresos</p>
                <h5 class="font-weight-bolder mb-0 text-success">{{ formatMoney(data.totals.total_revenue) }}</h5>
              </div>
            </div>
            <div class="col-4">
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">Total Pagado</p>
                <h5 class="font-weight-bolder mb-0">{{ formatMoney(data.totals.total_paid) }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">Servicio</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ingresos</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">% del Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(svc, idx) in data.services" :key="idx">
                <td class="text-sm ps-3 font-weight-bold">{{ svc.description }}</td>
                <td class="text-center text-sm">{{ svc.count }}</td>
                <td class="text-center text-sm text-success font-weight-bold">{{ formatMoney(svc.total_revenue) }}</td>
                <td class="text-center text-sm">
                  <div class="d-flex align-items-center justify-content-center gap-1">
                    <div style="width: 60px; height: 6px; background: #e9ecef; border-radius: 3px;">
                      <div :style="`width: ${svc.revenue_percent}%; height: 100%; background: #4caf50; border-radius: 3px;`"></div>
                    </div>
                    <span class="text-xs">{{ svc.revenue_percent }}%</span>
                  </div>
                </td>
              </tr>
              <tr v-if="data.services.length === 0">
                <td colspan="4" class="text-center text-sm text-secondary py-3">No hay datos para este periodo</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex align-items-center justify-content-between px-3 pt-2" v-if="data.pagination">
          <span class="text-xs text-secondary">
            {{ data.pagination.total }} registros · página {{ data.pagination.page }} de {{ data.pagination.last_page }}
          </span>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page <= 1" @click="changePage(data.pagination.page - 1)">Anterior</button>
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page >= data.pagination.last_page" @click="changePage(data.pagination.page + 1)">Siguiente</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaborByService',
  data() {
    const now = new Date();
    return {
      loading: false,
      data: null,
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
      search: '',
      page: 1,
      searchTimer: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('metrics/getLaborByService', {
          month: this.selectedMonth,
          year: this.selectedYear,
          search: this.search,
          page: this.page,
        });
        this.data = response.data;
      } catch (error) {
        console.error('Error loading labor by service:', error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.loadData();
      }, 400);
    },
    resetAndLoad() {
      this.page = 1;
      this.loadData();
    },
    changePage(page) {
      this.page = page;
      this.loadData();
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },
};
</script>
